import { render, staticRenderFns } from "./LidaiParty.vue?vue&type=template&id=a3380e54&scoped=true"
import script from "./LidaiParty.vue?vue&type=script&lang=js"
export * from "./LidaiParty.vue?vue&type=script&lang=js"
import style0 from "./LidaiParty.vue?vue&type=style&index=0&id=a3380e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3380e54",
  null
  
)

export default component.exports